import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress'
import { grey } from '@material-ui/core/colors'

export default ({ size }) => <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CircularProgress size={size || 40} style={{ padding: 30, color: grey[500] }} /></div>